import { Action } from "redux";

export type BimRevertSucceededEvent = Action<typeof BIM_REVERT_SUCCEEDED>

const bimRevertEventSuccess = (): BimRevertSucceededEvent => ({
  type: BIM_REVERT_SUCCEEDED,
});

export const BIM_REVERT_SUCCEEDED = "bim_revert_event_success";

export default bimRevertEventSuccess;
